
import DatePicker, { registerLocale } from 'react-datepicker';
import {useParams} from "react-router";
import WorkScheduleService from "../../../../../../../services/web/work-schedule-service.js";
import projectUtils from "../../../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";
import {useEffect, useRef, useState} from "react";
import {isSameDay, parseISO} from "date-fns";
import {ptBR} from "date-fns/locale/pt-BR";
import {Template} from "../../../../../../../components/template/template.jsx";
import {Card} from "../../../../../../../components/card/card.jsx";
import "react-datepicker/dist/react-datepicker.css";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {AgGridReact} from "ag-grid-react";
import styles from './work-schedule-batch-conflicts.module.css'
import ConflictResultPanel from "./components/conflict-result-panel.jsx";
import {translatedKeys} from "../../utils/work-schedule-i18n.js";
import {FaCircleCheck, FaCircleExclamation} from "react-icons/fa6";

registerLocale('pt-BR', ptBR);
const WorkScheduleBatchConflicts = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDates, setSelectedDates] = useState([
    ]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedEffective, setSelectedEffective] = useState(null);
    const [availableEffective, setAvailableEffective ] = useState([]);
    const [conflictRowDataState, setConflictRowDataState] = useState([]);
    const [solvedDates, setSolvedDates] = useState([]);
    const [name, setName] = useState("");
    const navigate = navigateHook();
    const gridRef = useRef(null);

    const [colDefs, setColDefs] = useState([
        { field: "id", hide:"true" },
        { field: "name", headerName: "Nome", flex: 1, filter: true, sortable: true, comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }},
        { field: "teamName", headerName: "Equipe", flex: 1, filter: true, sortable: true, comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }},
    ]);
    const [colDefs1, setColDefs1] = useState(
        [
            {
                headerName: "Data", field: "startDate",sortable: false, width: 150, sort: 'asc',
                cellRenderer: params => {
                    return <>{projectUtils.formatDate(params.value)}</>
                }
            },
            {headerName: "Conflito", field: "id", hide: true},
            {headerName: "Efetivo", field: "effectiveName", flex: 1, comparator: (a, b, nodeA, nodeB, isInverted) => {
                    return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
                }},
            {
                headerName: "Motivo", field: "observation", sortable: true, flex: 1, comparator: (a, b, nodeA, nodeB, isInverted) => {
                    return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
                },
                valueGetter: params => {
                    const obs = params.data.observation;

                    if (!obs) return "";

                    return obs
                      .split(",")
                      .map(item => item.trim())
                      .map(item => translatedKeys[item] ?? item)
                      .sort((a, b) => a.localeCompare(b, 'pt-BR'))
                      .join(", ");
                }
            },
            {headerName: "Substituído por", field: "substitute", sortable: true, flex: 1, comparator: (a, b, nodeA, nodeB, isInverted) => {
                    return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
                }},
            {headerName: "", field: "conflictStatus", filter: false, sortable: false, width: 60, lockPosition: 'right', suppressMovable: true,
                comparator: (a, b, nodeA, nodeB, isInverted) => {
                    return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
                },
                cellRenderer: (params) => {
                    return params.data.substitute ? <div className="h-full w-full flex justify-center items-center"><FaCircleCheck color="#31b131" size={18}/></div>
                        :  <div className="h-full w-full flex justify-center items-center"><FaCircleExclamation color="#e6b800" size={18}/></div>
                }}
        ]
    )
    const [defaultColDef] = useState({
        filter: true,
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        suppressFloatingFilterButton: true,
        resizable: false,
    })

    useEffect(() => {
        const tableData = localStorage.getItem("substituteTableData");
        const conflicts = localStorage.getItem("conflictsById");
        const workScheduleName = localStorage.getItem("workScheduleName");
        if(tableData){
            setConflictRowDataState(JSON.parse(tableData));
            localStorage.removeItem("substituteTableData");
        }
        if(conflicts){
            setAvailableEffective(JSON.parse(conflicts));
            localStorage.removeItem("conflictsById");
        }
        if(workScheduleName){
            setName(workScheduleName);
            localStorage.removeItem('workScheduleName')
        }
    }, []);

    useEffect(() => {
        setSolvedDates(conflictRowDataState.filter(el => el.substitute).map(el => el.startDate));
    }, [conflictRowDataState]);

    useEffect(() => {
        const getAvailableEffective = () => {
            const conflictsForSelectedDates = availableEffective.filter(conflict =>
                selectedDates.some(date => isSameDay(date, new Date(conflict.date)))
            );

            if (conflictsForSelectedDates.length === 0) return [];

            let commonIds = new Set(conflictsForSelectedDates[0].availableEffective.map(e => e.id));

            for (let i = 1; i < conflictsForSelectedDates.length; i++) {
                const currentIds = new Set(conflictsForSelectedDates[i].availableEffective.map(e => e.id));
                commonIds = new Set([...commonIds].filter(id => currentIds.has(id)));
            }

            return conflictsForSelectedDates[0].availableEffective
                .filter(e => commonIds.has(e.id))
                .map(e => ({
                    id: e.id,
                    name: e.name,
                    teamName: e.teamName,
                }));
        };

        setFilteredData(getAvailableEffective());
    }, [selectedDates, availableEffective]);

    const onChange = (dates) => {
        setSelectedEffective(null);
        setSelectedDates(dates);
    };

    const dateStateClass = (currentDate) => {
        if(solvedDates.find(el => isSameDay(el, currentDate))) return styles.solved
        if(conflictRowDataState.find(el => isSameDay(new Date(el.startDate), currentDate))) return styles.notSolved
        return "";
    }

    const updateStateTable = (data) => {
        const possibleToResolve = availableEffective
            .filter(conflict => selectedDates.some(date => isSameDay(date, conflict.date)))
            .map(conflict => conflict.id);

        setConflictRowDataState(prevItems =>
            prevItems.map(item =>
                possibleToResolve.includes(item.id)
                    ? {
                        ...item,
                        substitute_id: data ? parseInt(data.id) : null,
                        substitute: data ? data.name : "Sem substituto",
                    }
                    : item
            )
        );

        if (gridRef.current) {
            gridRef.current.api.deselectAll();
            setSelectedEffective(null)
        }
        setSelectedDates([]);
    };

    const confirmChanges = () => {
        return conflictRowDataState.filter(el => el.substitute !== "").map(conflict => {
            if(conflict.substitute === "Sem substituto"){
                return {
                    conflictId: conflict.id,
                    substituteId: null,
                    isIgnoreSubstitute: true
                }
            }
            else {
                return {
                    conflictId: conflict.id,
                    substituteId: conflict.substitute_id,
                    isIgnoreSubstitute: false
                }
            }
        })
    }

    const saveConflicts = () => {
        setIsLoading(true);
        const dataToSend = {
            workScheduleId: parseInt(id),
            resolveConflicts: confirmChanges()
        }

        WorkScheduleService.resolveConflicts(dataToSend)
            .then(({data}) => {
                const {hasConflictUnresolved, hasConflictByWorkSchedule} = data;
                let messageWarning = "Ainda há conflitos a serem solucionados";
                if (hasConflictUnresolved) {
                    //     "Não foi possível solucionar alguns conflitos, pois o efetivo não está mais disponível na data referente";
                    localStorage.setItem('warning', messageWarning);
                    navigate(`/work-schedule/conflicts/${id}`, false)
                } else if (hasConflictByWorkSchedule) {
                    localStorage.setItem('warning', messageWarning);
                    navigate(`/work-schedule/conflicts/${id}`, false)
                } else {
                    projectUtils.success(true);
                    navigate(`/work-schedule/form/${id}`, false)
                }
            }).catch(error => {
            console.error(error);
            projectUtils.swalErrorMessage('', "Não foi possível salvar.", 'Ok');
        }).finally(() => setIsLoading(false))
    }

    return(
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Conflitos {name && ` - ${name}` } {conflictRowDataState.length > 0 && "- " + conflictRowDataState[0].effectiveName}</Template.Title>
            </Template.Header>
            <Template.Body>
                <div className="flex gap-2">
                    <Card>
                        <Card.Header>
                            <Card.Title>Selecionar múltiplas datas</Card.Title>
                        </Card.Header>
                        <Card.Body className={styles.datePickerContainer}>
                            <DatePicker
                                selectedDates={selectedDates}
                                selectsMultiple
                                onChange={onChange}
                                locale='pt-BR'
                                inline
                                openToDate={conflictRowDataState.length > 0 ? parseISO(conflictRowDataState[0].startDate) : new Date()}
                                filterDate={(date) => conflictRowDataState.some(el => isSameDay(new Date(el.startDate),date))}
                                dayClassName={(date) => dateStateClass(date)}
                                showMonthYearDropdown={false}
                            />
                        </Card.Body>
                    </Card>
                    <Card className="flex-1">
                        <Card.Header>
                            <Card.Title>Selecionar substitutos</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <div className={styles.custom} style={{height: "238px", width: "100%"}}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={filteredData}
                                    defaultColDef={defaultColDef}
                                    columnDefs={colDefs}
                                    suppressCellFocus={true}
                                    rowSelection={{
                                        mode: 'singleRow',
                                        checkboxes: false,
                                        headerCheckbox: false,
                                        enableClickSelection: true
                                    }}
                                    onSelectionChanged={(event) => {
                                        const selectedRows = event.api.getSelectedRows();
                                        if (selectedRows.length > 0) {
                                            setSelectedEffective(selectedRows[0]);
                                        } else {
                                            setSelectedEffective(null);
                                        }
                                    }}
                                    animateRows={false}
                                    gridOptions={{localeText: {...aggridUtils.localization(), noRowsToShow: 'Selecione uma ou mais datas para verificar o efetivo disponível.'}}}
                                    theme={aggridUtils.generalTheme({rowHeight: 40, headerHeight: 40})}
                                />
                            </div>
                            <div className="flex gap-[2px] w-full justify-end p-[6px] border-l border-r border-b border-[#dcdddd]">

                                <Button target="danger" disabled={selectedDates.length === 0}
                                        onClick={() => updateStateTable(null)}>Não substituir</Button>
                                <Button target="success" disabled={!selectedEffective}
                                        onClick={() => updateStateTable(selectedEffective)}>Substituir efetivo</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <Card className="mt-2">
                    <Card.Header>
                        <Card.Title>Lista de substituição</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div style={{height: "calc(100vh - 569px)"}}>
                            <AgGridReact
                                animateRows={false}
                                suppressCellFocus={true}
                                rowData={conflictRowDataState}
                                columnDefs={colDefs1}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                        <ConflictResultPanel
                            totalConflicts={conflictRowDataState.length ?? 0}
                            solvedConflicts={conflictRowDataState.filter(item => item.substitute).length ?? 0}
                            notSolvedConflicts={conflictRowDataState.filter(item => !item.substitute).length ?? 0}
                        />
                    </Card.Body>
                </Card>
                <Card className="mt-2">
                    <Card.Body>
                        <div className="flex w-full justify-end gap-2">
                            <Button target="primary" onClick={saveConflicts} actionFeedbackType='save'>Salvar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default WorkScheduleBatchConflicts;